import {useMemo} from 'react';
import {Moment} from 'moment';
import {Card, LinearProgress} from '@mui/material';
import {DateRangeType} from '../../../../../../../components/date-range-input/date-range-utils';
import {PlannerDisplayMode} from '../shared/planner-display-mode';
import {transformPlannerItems2PlannerSections} from './planner-data-transformation';
import {OnPlannerItemClicked, PlannerItem} from './planner-item';
import {PlannerFetchData} from './use-planner-fetch-data';
import {PlannerList} from './planner-list/planner-list';
import {PlannerCalendar} from './planner-calendar';

export type PlannerBodyProps = {
  data: PlannerFetchData;
  display: PlannerDisplayMode;
  range: DateRangeType;
  date: Moment;
  isLoading: boolean;
  itemSelected?: PlannerItem;
  onItemClicked: OnPlannerItemClicked;
};

export function PlannerBody({
  data,
  display,
  date,
  range,
  isLoading,
  itemSelected,
  onItemClicked,
}: PlannerBodyProps) {
  const sections = useMemo(() => transformPlannerItems2PlannerSections(data.items), [data]);

  return (
    <Card
      elevation={0}
      sx={{
        px: '9px',
        py: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
        height: 'calc(100vh - 210px)',
        position: 'relative',
      }}
    >
      {/* --------- LOADING --------- */}
      {data.fetching && (
        <LinearProgress
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
          }}
        />
      )}

      {/* --------- DISPLAY --------- */}
      {display === 'calendar' ? (
        /* --------- CALENDAR VIEW --------- */
        <PlannerCalendar
          items={data.items}
          itemsLoading={data.fetching}
          range={range}
          date={date}
          onItemClicked={onItemClicked}
        />
      ) : (
        /* --------- LIST VIEW --------- */
        !isLoading && (
          <PlannerList
            sections={sections}
            onItemClicked={onItemClicked}
            itemSelected={itemSelected}
          />
        )
      )}
    </Card>
  );
}
